module.exports = __webpack_public_path__ + "img/调色滤镜.e8f01ce7.png";